export const typeIcons = {
  AR: '/images/assets/Icon_AR.png',
  SMG: '/images/assets/Icon_SMG.png',
  RF: '/images/assets/Icon_RF.png',
  HG: '/images/assets/Icon_HG.png',
  SG: '/images/assets/Icon_SG.png',
  MG: '/images/assets/Icon_MG.png',
  SF: '/images/assets/Icon_conSF.png',
  NPC: '/images/assets/Icon_NPC.png',
}
